"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3258],{

/***/ 77521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ getCosmosCalcSigningClient; },
  "z": function() { return /* binding */ getGrantMsg; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/helpers/strategy/index.ts + 2 modules
var helpers_strategy = __webpack_require__(6686);
// EXTERNAL MODULE: ./node_modules/@cosmjs/proto-signing/build/index.js
var build = __webpack_require__(74087);
// EXTERNAL MODULE: ./node_modules/cosmjs-types/cosmos/bank/v1beta1/tx.js
var tx = __webpack_require__(98994);
// EXTERNAL MODULE: ./node_modules/cosmjs-types/cosmwasm/wasm/v1/tx.js
var v1_tx = __webpack_require__(2387);
;// CONCATENATED MODULE: ./src/helpers/getFeeMessage.ts



function getFeeMessage(senderAddress, denom, amount, feeTakerAddress) {
  return denom.isCw20 ? {
    typeUrl: '/cosmwasm.wasm.v1.MsgExecuteContract',
    value: v1_tx.MsgExecuteContract.fromPartial({
      contract: denom.id,
      msg: new TextEncoder().encode(JSON.stringify({
        transfer: {
          recipient: feeTakerAddress,
          amount: amount
        }
      })),
      sender: senderAddress
    })
  } : {
    typeUrl: '/cosmos.bank.v1beta1.MsgSend',
    value: tx.MsgSend.fromPartial({
      amount: [(0,build.coin)(amount, denom.id)],
      fromAddress: senderAddress,
      toAddress: feeTakerAddress
    })
  };
}
// EXTERNAL MODULE: ./src/hooks/useCreateVault/buildCreateVaultParams/index.ts
var buildCreateVaultParams = __webpack_require__(50111);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
;// CONCATENATED MODULE: ./src/helpers/api/signAndBroadcast.ts



function signAndBroadcast(_x, _x2, _x3) {
  return _signAndBroadcast.apply(this, arguments);
}

function _signAndBroadcast() {
  _signAndBroadcast = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client, senderAddress, msgs) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return client.signAndBroadcast(senderAddress, msgs, 1.6);

          case 3:
            return _context.abrupt("return", _context.sent);

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);

            if (!_context.t0.toString().includes('transaction indexing is disabled')) {
              _context.next = 11;
              break;
            }

            esm_exports/* captureException */.Tb(_context.t0, {
              tags: {
                page: 'signAndBroadcast'
              }
            });
            return _context.abrupt("return", Promise.resolve(undefined));

          case 11:
            throw new Error(_context.t0);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  }));
  return _signAndBroadcast.apply(this, arguments);
}
;// CONCATENATED MODULE: ./src/hooks/useCreateVault/executeCreateVault.ts





function getStrategyIdFromEvents(events) {
  var _events$find, _events$find$attribut;

  return (_events$find = events.find(function (event) {
    return event.type === 'wasm';
  })) === null || _events$find === void 0 ? void 0 : (_events$find$attribut = _events$find.attributes.find(function (attribute) {
    return attribute.key === 'vault_id';
  })) === null || _events$find$attribut === void 0 ? void 0 : _events$find$attribut.value;
}

function getVaultIdFromDeliverTxResponse(data) {
  var id = (data === null || data === void 0 ? void 0 : data.events) && getStrategyIdFromEvents(data.events);

  if (id) {
    return id;
  }

  throw new Error('Transaction succeeded but vault creation failed.');
}
function executeCreateVault(_x, _x2, _x3) {
  return _executeCreateVault.apply(this, arguments);
}

function _executeCreateVault() {
  _executeCreateVault = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client, senderAddress, msgs) {
    var errorMatchers, matchingErrorKey;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.t0 = getVaultIdFromDeliverTxResponse;
            _context.next = 4;
            return signAndBroadcast(client, senderAddress, msgs);

          case 4:
            _context.t1 = _context.sent;
            return _context.abrupt("return", (0, _context.t0)(_context.t1));

          case 8:
            _context.prev = 8;
            _context.t2 = _context["catch"](0);
            console.error(_context.t2);
            errorMatchers = {
              'out of gas': constants/* OUT_OF_GAS_ERROR_MESSAGE */.tS,
              'Transaction succeeded but vault creation failed.': 'Vault was not created. This is most likely due to insufficient fees. Please ensure you have enough for the vault deposit and gas.',
              'Failed to fetch': 'Something went wrong when submitting, please try again.',
              // 'insufficient fees': 'Insufficient fees. Please ensure you have enough for the transaction fees and gas.',
              "Type URL '/cosmos.authz.v1beta1.MsgGrant' does not exist in the Amino message type register": constants/* LEDGER_AUTHZ_NOT_INCLUDED_ERROR_MESSAGE */.Dw,
              'transaction indexing is disabled': constants/* TRANSACTION_INDEXING_DISABLED_ERROR_MESSAGE */.fd
            };
            matchingErrorKey = Object.keys(errorMatchers).find(function (key) {
              return _context.t2.toString().includes(key);
            });
            throw new Error(matchingErrorKey ? errorMatchers[matchingErrorKey] : _context.t2);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _executeCreateVault.apply(this, arguments);
}
// EXTERNAL MODULE: ./src/hooks/useCreateVault/getCreateVaultExecuteMsg.ts + 1 modules
var getCreateVaultExecuteMsg = __webpack_require__(5159);
// EXTERNAL MODULE: ./node_modules/cosmjs-types/cosmos/staking/v1beta1/authz.js
var authz = __webpack_require__(28220);
// EXTERNAL MODULE: ./node_modules/cosmjs-types/cosmos/base/v1beta1/coin.js
var coin = __webpack_require__(10891);
// EXTERNAL MODULE: ./node_modules/cosmjs-types/cosmos/authz/v1beta1/authz.js
var v1beta1_authz = __webpack_require__(18436);
// EXTERNAL MODULE: ./node_modules/cosmjs-types/cosmos/authz/v1beta1/tx.js
var v1beta1_tx = __webpack_require__(70895);
// EXTERNAL MODULE: ./node_modules/cosmjs-types/google/protobuf/timestamp.js
var timestamp = __webpack_require__(85522);
// EXTERNAL MODULE: ./src/utils/getDenomInfo.tsx
var getDenomInfo = __webpack_require__(11599);
;// CONCATENATED MODULE: ./src/hooks/useCalcSigningClient/getClient/clients/cosmos/index.ts















function assertChainIsNotRetired(chainId) {
  if ((0,constants/* isChainRetired */.Z8)(chainId)) {
    throw new Error(constants/* RETIREMENT_ERROR_MESSAGE */.dj);
  }
}

function _topUpStrategy(address, client, chainConfig, strategy, topUpAmount) {
  assertChainIsNotRetired(chainConfig.id);

  if (strategy.owner !== address) {
    throw new Error('You are not the owner of this strategy');
  }

  var initialDenom = (0,helpers_strategy/* getStrategyInitialDenom */.vB)(strategy);
  var msg = {
    deposit: {
      vault_id: strategy.id,
      address: address
    }
  };
  var funds = [{
    denom: initialDenom.id,
    amount: BigInt((0,getDenomInfo/* toAtomic */.Iy)(initialDenom, topUpAmount)).toString()
  }];
  return client.execute(address, chainConfig.contractAddress, msg, 'auto', undefined, funds);
}

var getGrantMsg = function getGrantMsg(granter, grantee) {
  var typeUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/cosmos.authz.v1beta1.GenericAuthorization';
  var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : v1beta1_authz.GenericAuthorization.encode(v1beta1_authz.GenericAuthorization.fromPartial({
    msg: '/cosmos.staking.v1beta1.MsgDelegate'
  })).finish();
  var seconds = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : BigInt(Math.round(new Date().getTime() / 1000 + 60 * 60 * 24 * 365));
  return {
    typeUrl: '/cosmos.authz.v1beta1.MsgGrant',
    value: v1beta1_tx.MsgGrant.fromPartial({
      granter: granter,
      grantee: grantee,
      grant: {
        authorization: {
          typeUrl: typeUrl,
          value: value
        },
        expiration: timestamp.Timestamp.fromPartial({
          seconds: seconds
        })
      }
    })
  };
};

function addStakingGrants(autoStakeValidator, msgs, senderAddress, chainConfig, autoCompoundStakingRewards) {
  if (autoStakeValidator) {
    msgs.push(getGrantMsg(senderAddress, chainConfig.contractAddress));

    if (autoCompoundStakingRewards) {
      msgs.push(getGrantMsg(senderAddress, chainConfig.autoCompoundStakingRewardsAddress, '/cosmos.staking.v1beta1.StakeAuthorization', authz/* StakeAuthorization.encode */.sf.encode(authz/* StakeAuthorization.fromPartial */.sf.fromPartial({
        authorizationType: authz/* AuthorizationType.AUTHORIZATION_TYPE_DELEGATE */.Mv.AUTHORIZATION_TYPE_DELEGATE,
        allowList: {
          address: [autoStakeValidator]
        }
      })).finish()));
    }
  }
}

function _createStrategy2(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
  return _createStrategy.apply(this, arguments);
}

function _createStrategy() {
  _createStrategy = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(signer, chainConfig, fetchedConfig, senderAddress, initialDeposit, fee, createVaultContext) {
    var createVaultMsg, msgs, funds;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            assertChainIsNotRetired(chainConfig.id);
            createVaultMsg = (0,buildCreateVaultParams/* buildCreateVaultMsg */.WS)(chainConfig, fetchedConfig, createVaultContext);
            msgs = [];
            funds = [coin.Coin.fromPartial({
              amount: BigInt(Math.round(initialDeposit)).toString(),
              denom: createVaultContext.initialDenom.id
            })];
            msgs.push((0,getCreateVaultExecuteMsg/* getExecuteMsg */.u)(createVaultMsg, funds, senderAddress, chainConfig.contractAddress, createVaultContext.initialDenom));
            addStakingGrants(createVaultContext.destinationConfig.autoStakeValidator, msgs, senderAddress, chainConfig, createVaultContext.destinationConfig.autoCompoundStakingRewards);

            if (fee) {
              msgs.push(getFeeMessage(senderAddress, createVaultContext.initialDenom, fee, chainConfig.feeTakerAddress));
            }

            return _context.abrupt("return", executeCreateVault(signer, senderAddress, msgs));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createStrategy.apply(this, arguments);
}

function getCosmosCalcSigningClient(signingClient, chainConfig, fetchedConfig) {
  return {
    topUpStrategy: function topUpStrategy(address, strategy, topUpAmount) {
      return _topUpStrategy(address, signingClient, chainConfig, strategy, topUpAmount);
    },
    createStrategy: function createStrategy(address, initialDeposit, fee, variables) {
      return _createStrategy2(signingClient, chainConfig, fetchedConfig, address, initialDeposit, fee, variables);
    }
  };
}

/***/ }),

/***/ 79149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useConfig; }
/* harmony export */ });
/* harmony import */ var _helpers_chains__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87038);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67848);
/* harmony import */ var _hooks_useChainId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12680);
/* harmony import */ var _hooks_useCosmWasmClient__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32178);




function useConfig(injectedChainId) {
  var _useChainId = (0,_hooks_useChainId__WEBPACK_IMPORTED_MODULE_1__/* .useChainId */ .x)(),
      currentChainId = _useChainId.chainId;

  var _useCosmWasmClient = (0,_hooks_useCosmWasmClient__WEBPACK_IMPORTED_MODULE_2__/* .useCosmWasmClient */ .h)(),
      cosmWasmClient = _useCosmWasmClient.cosmWasmClient;

  var chainId = injectedChainId !== null && injectedChainId !== void 0 ? injectedChainId : currentChainId;

  var _useQuery = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)(['config', chainId], function () {
    return cosmWasmClient.queryContractSmart((0,_helpers_chains__WEBPACK_IMPORTED_MODULE_0__/* .getDCAContractAddress */ .cr)(chainId), {
      get_config: {}
    });
  }, {
    enabled: !!chainId && !!cosmWasmClient,
    meta: {
      errorMessage: 'Error fetching config'
    }
  }),
      response = _useQuery.data;

  return response && response.config;
}

/***/ }),

/***/ 50111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M$": function() { return /* binding */ buildWeightedScaleAdjustmentStrategy; },
/* harmony export */   "VW": function() { return /* binding */ getSlippageWithoutTrailingZeros; },
/* harmony export */   "WS": function() { return /* binding */ buildCreateVaultMsg; },
/* harmony export */   "dI": function() { return /* binding */ buildCallbackDestinations; },
/* harmony export */   "kE": function() { return /* binding */ getExecutionInterval; },
/* harmony export */   "nC": function() { return /* binding */ getReceiveAmount; }
/* harmony export */ });
/* unused harmony export getSwapAmount */
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _components_TransactionType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95709);
/* harmony import */ var _helpers_combineDateAndTime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99316);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18459);
/* harmony import */ var _helpers_chains__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87038);
/* harmony import */ var _utils_safeInvert__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90019);
/* harmony import */ var _utils_getDenomInfo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11599);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







function getSlippageWithoutTrailingZeros(slippage) {
  return parseFloat((slippage / 100).toFixed(4)).toString();
}
function buildCallbackDestinations(chainConfig, autoStakeValidator, recipientAccount, yieldOption, senderAddress, reinvestStrategyId) {
  var destinations = [];

  if (autoStakeValidator) {
    destinations.push({
      address: chainConfig.contractAddress,
      allocation: '1.0',
      msg: Buffer.from(JSON.stringify({
        z_delegate: {
          delegator_address: senderAddress,
          validator_address: autoStakeValidator
        }
      })).toString('base64')
    });
  }

  if (recipientAccount) {
    destinations.push({
      address: recipientAccount,
      allocation: '1.0',
      msg: null
    });
  }

  if (reinvestStrategyId) {
    var msg = {
      deposit: {
        vault_id: reinvestStrategyId,
        address: senderAddress
      }
    };
    destinations.push({
      address: chainConfig.contractAddress,
      allocation: '1.0',
      msg: Buffer.from(JSON.stringify(msg)).toString('base64')
    });
  }

  if (yieldOption) {
    if (yieldOption === 'mars') {
      var _msg = {
        deposit: {
          on_behalf_of: senderAddress
        }
      };
      var redBankAddress = (0,_helpers_chains__WEBPACK_IMPORTED_MODULE_3__/* .getRedBankAddress */ .uP)(chainConfig.id);

      if (!redBankAddress) {
        throw new Error("Red bank not supported on ".concat((0,_helpers_chains__WEBPACK_IMPORTED_MODULE_3__/* .getChainName */ .qz)(chainConfig.id)));
      }

      destinations.push({
        address: redBankAddress,
        allocation: '1.0',
        msg: Buffer.from(JSON.stringify(_msg)).toString('base64')
      });
    }
  }

  return destinations.length ? destinations : undefined;
}
function getReceiveAmount(initialDenom, swapAmount, price, resultingDenom, transactionType) {
  var directionlessPrice = transactionType === _components_TransactionType__WEBPACK_IMPORTED_MODULE_1__/* .TransactionType.Buy */ .i.Buy ? price : (0,_utils_safeInvert__WEBPACK_IMPORTED_MODULE_4__/* .safeInvert */ .Z)(price);
  var unscaledReceiveAmount = Math.round(swapAmount / directionlessPrice);
  var scalingFactor = 10 ** (resultingDenom.significantFigures - initialDenom.significantFigures);
  var scaledReceiveAmount = BigInt(Math.round(unscaledReceiveAmount * scalingFactor));
  return scaledReceiveAmount.toString();
}

function getStartTime(startDate, purchaseTime) {
  var startTimeSeconds;

  if (startDate) {
    var startTime = (0,_helpers_combineDateAndTime__WEBPACK_IMPORTED_MODULE_6__/* .combineDateAndTime */ .Z)(startDate, purchaseTime);
    startTimeSeconds = (startTime.valueOf() / 1000).toString();
  }

  return startTimeSeconds;
}

function getSwapAmount(initialDenom, swapAmount) {
  return BigInt(toAtomic(initialDenom, swapAmount)).toString();
}
function getExecutionInterval(executionInterval, executionIntervalIncrement) {
  var conversion = {
    minute: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .SECONDS_IN_A_MINUTE */ .JJ,
    half_hourly: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .SECONDS_IN_A_HOUR */ .sb / 2,
    hourly: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .SECONDS_IN_A_HOUR */ .sb,
    half_daily: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .SECONDS_IN_A_DAY */ .K5 / 2,
    daily: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .SECONDS_IN_A_DAY */ .K5,
    weekly: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .SECONDS_IN_A_WEEK */ .Jp,
    fortnightly: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .SECONDS_IN_A_WEEK */ .Jp * 2,
    monthly: src_constants__WEBPACK_IMPORTED_MODULE_2__/* .SECONDS_IN_A_WEEK */ .Jp * 4
  };
  return {
    custom: {
      seconds: executionIntervalIncrement * conversion[executionInterval]
    }
  };
}
function buildWeightedScaleAdjustmentStrategy(initialDenom, swapAmount, basePriceValue, resultingDenom, transactionType, increaseOnly, swapMultiplier) {
  return {
    weighted_scale: {
      base_receive_amount: getReceiveAmount(initialDenom, swapAmount, basePriceValue, resultingDenom, transactionType),
      increase_only: increaseOnly,
      multiplier: swapMultiplier.toString()
    }
  };
}

function buildDcaPlusAdjustmentStrategy(transactionType, fetchedConfig) {
  return {
    risk_weighted_average: _objectSpread({
      base_denom: 'bitcoin'
    }, !!fetchedConfig && fetchedConfig.exchange_contract_address && {
      position_type: transactionType === _components_TransactionType__WEBPACK_IMPORTED_MODULE_1__/* .TransactionType.Buy */ .i.Buy ? 'enter' : 'exit'
    })
  };
}

function buildCreateVaultMsg(chainConfig, fetchedConfig, _ref) {
  var label = _ref.label,
      initialDenom = _ref.initialDenom,
      resultingDenom = _ref.resultingDenom,
      route = _ref.route,
      timeTrigger = _ref.timeTrigger,
      startPrice = _ref.startPrice,
      timeInterval = _ref.timeInterval,
      swapAmount = _ref.swapAmount,
      priceThreshold = _ref.priceThreshold,
      transactionType = _ref.transactionType,
      slippageTolerance = _ref.slippageTolerance,
      destinationConfig = _ref.destinationConfig,
      swapAdjustment = _ref.swapAdjustment,
      isDcaPlus = _ref.isDcaPlus;

  if (isDcaPlus && swapAdjustment) {
    throw new Error('Swap adjustment is not supported for DCA+');
  }

  var swapAdjustmentStrategy = swapAdjustment ? buildWeightedScaleAdjustmentStrategy(initialDenom, swapAmount, swapAdjustment.basePrice, resultingDenom, transactionType, swapAdjustment.increaseOnly, swapAdjustment.swapMultiplier) : isDcaPlus ? buildDcaPlusAdjustmentStrategy(transactionType, fetchedConfig) : undefined;
  var performanceAssessmentStrategy = isDcaPlus ? 'compare_to_standard_dca' : undefined;
  return {
    create_vault: {
      label: label,
      time_interval: getExecutionInterval(timeInterval.interval, timeInterval.increment),
      target_denom: resultingDenom.id,
      route: route,
      swap_amount: BigInt(Math.round(swapAmount)).toString(),
      target_start_time_utc_seconds: timeTrigger && getStartTime(timeTrigger.startDate, timeTrigger.startTime),
      minimum_receive_amount: priceThreshold ? getReceiveAmount(initialDenom, swapAmount, priceThreshold, resultingDenom, transactionType) : undefined,
      slippage_tolerance: slippageTolerance ? getSlippageWithoutTrailingZeros(slippageTolerance) : null,
      destinations: buildCallbackDestinations(chainConfig, destinationConfig.autoStakeValidator, destinationConfig.recipientAccount, destinationConfig.yieldOption, destinationConfig.senderAddress, destinationConfig.reinvestStrategyId),
      target_receive_amount: startPrice ? getReceiveAmount(initialDenom, swapAmount, startPrice, resultingDenom, transactionType) : undefined,
      swap_adjustment_strategy: swapAdjustmentStrategy,
      performance_assessment_strategy: performanceAssessmentStrategy
    }
  };
}

/***/ }),

/***/ 5159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ getExecuteMsg; }
});

;// CONCATENATED MODULE: ./src/helpers/base64/index.ts
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
function toBase64(obj) {
  return Buffer.from(JSON.stringify(obj)).toString('base64');
}
// EXTERNAL MODULE: ./node_modules/cosmjs-types/cosmwasm/wasm/v1/tx.js
var tx = __webpack_require__(2387);
;// CONCATENATED MODULE: ./src/hooks/useCreateVault/getCreateVaultExecuteMsg.ts


function getExecuteMsg(msg, funds, senderAddress, contractAddress, initialDenom) {
  var encodedMsg = new TextEncoder().encode(JSON.stringify(msg));
  return initialDenom.isCw20 && funds ? {
    typeUrl: '/cosmwasm.wasm.v1.MsgExecuteContract',
    value: tx.MsgExecuteContract.fromPartial({
      contract: initialDenom.id,
      msg: new TextEncoder().encode(JSON.stringify({
        send: {
          contract: contractAddress,
          amount: funds[0].amount,
          msg: toBase64(msg)
        }
      })),
      sender: senderAddress
    })
  } : {
    typeUrl: '/cosmwasm.wasm.v1.MsgExecuteContract',
    value: tx.MsgExecuteContract.fromPartial({
      contract: contractAddress,
      funds: funds,
      msg: encodedMsg,
      sender: senderAddress
    })
  };
}

/***/ })

}]);